export default __webpack_public_path__ + "static/media/timer_xl1.c04ac8e4.png";